type HttpHeaders = {
  normalizedNames: object;
  lazyUpdate: null;
};

type ClientException = {
  id: string;
  name: string;
  message: string;
  path: string;
  httpStatus: number;
  timestamp: string;
  clientSubject: string;
  clientBody: string;
  details: any;
};

export class Exception {
  headers: HttpHeaders;
  status: number;
  statusText: string;
  url: string;
  ok: boolean;
  name: string;
  message: string;
  clientException: ClientException;

  constructor(data: any) {
    this.headers = data.headers;
    this.status = data.status;
    this.statusText = data.statusText;
    this.url = data.url;
    this.ok = data.ok;
    this.name = data.name;
    this.message = data.message;
    this.clientException = data.error;
  }
}
